import { useContext, useEffect } from 'react'

const useResponseStatus = (OEContext, responseId, action, onKeyDownHandler) => {
  const { searchState, commentStatusesState } = useContext(OEContext)
  const { isQAMode, qaAction, qaTotal, qaCounter, isLoading, isProcessing, qaProcessedResponseId } = searchState
  const status = commentStatusesState[action][responseId]

  useEffect(() => {
    if (isQAMode) {
      window.addEventListener('keydown', onKeyDownHandler)
    }

    return () => {
      window.removeEventListener('keydown', onKeyDownHandler)
    }
  }, [isQAMode, onKeyDownHandler])

  return { status, isQAMode, qaAction, qaTotal, qaCounter, isLoading, isProcessing, qaProcessedResponseId }
}

export default useResponseStatus
